import URI from "urijs";
export function routeSatisfies(condition) {
  const { pathname, search } = window.location;
  const params = URI(search).query(true);
  if (condition.pathIncludes && !pathname.includes(condition.pathIncludes)) {
    return false;
  }
  if (condition.queryParamPresent && !(condition.queryParamPresent in params)) {
    return false;
  }
  if (condition.queryIncludes) {
    for (const [key, value] of Object.entries(condition.queryIncludes)) {
      if (params[key] !== value) {
        return false;
      }
    }
  }
  return true;
}
export function onRouteChange(callback) {
  const wrap = (fn) => function wrapped(...args) {
    const result = fn.apply(this, args);
    callback();
    return result;
  };
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;
  window.history.pushState = wrap(originalPushState);
  window.history.replaceState = wrap(originalReplaceState);
  window.addEventListener("popstate", callback);
  return () => {
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
    window.removeEventListener("popstate", callback);
  };
}
